export enum AutomationTaskStep {
    decrypt = "decrypt",
    analyze = "analyze",
    tuner_search = "tuner_search",
    assembly = "assembly",
}

export enum AutomationTaskStatus {
    pending = "pending",
    in_progress = "in_progress",
    completed = "completed",
    failed = "failed",
}

export interface IAutomationTask {
    id: number;
    step: AutomationTaskStep;
    status: AutomationTaskStatus;
    error?: any | null;
    metadata?: any | null;
    createdAt: string | Date;
    updatedAt: string | Date;
}

